/** Persist the last open Copilot chat across refresh and browser relaunch. */
const LAST_CHAT_KEY = "labwizard.copilot.lastChatId"

export function readLastCopilotChatId(): string {
  try {
    return (
      window.localStorage.getItem(LAST_CHAT_KEY) ||
      window.sessionStorage.getItem(LAST_CHAT_KEY) ||
      ""
    )
  } catch {
    return ""
  }
}

export function rememberLastCopilotChatId(chatId: string) {
  const id = (chatId || "").trim()
  if (!id) return
  try {
    window.localStorage.setItem(LAST_CHAT_KEY, id)
    window.sessionStorage.setItem(LAST_CHAT_KEY, id)
  } catch {
    // Ignore private-mode / quota failures; history list still works.
  }
}

export function clearLastCopilotChatId() {
  try {
    window.localStorage.removeItem(LAST_CHAT_KEY)
    window.sessionStorage.removeItem(LAST_CHAT_KEY)
  } catch {
    // ignore
  }
}
